import { queryOptions, useQuery } from '@tanstack/react-query'
import { ArticleNotFoundError, loadAllArticles, loadArticle } from './articles'

export const helpArticleQuery = (slug: string) =>
  queryOptions({
    queryKey: ['help', 'article', slug],
    queryFn: () => loadArticle(slug),
    staleTime: Infinity,
    gcTime: Infinity,
    retry: (n, e) => !(e instanceof ArticleNotFoundError) && n < 2,
  })

export const helpIndexQuery = queryOptions({
  queryKey: ['help', 'all'],
  queryFn: loadAllArticles,
  staleTime: Infinity,
  gcTime: Infinity,
})

export function useHelpArticle(slug: string) {
  return useQuery(helpArticleQuery(slug))
}

/** Every article (with body text for search). Pass `enabled: false` to defer loading. */
export function useHelpIndex(enabled = true) {
  return useQuery({ ...helpIndexQuery, enabled })
}
